import styled from 'styled-components';
import { motion } from 'framer-motion';
import breakpoints from 'theme/atoms/breakpoints';
import * as Buttons from 'theme/components/Buttons.style';

export const CircularIconButton = styled(Buttons.SecondaryLightIcon).attrs({
  $size: 'medium' as const,
})`
  aspect-ratio: 1;
  flex-shrink: 0;
  min-width: unset;
`;

interface BackButtonProps {
  $hideOnDesktop?: boolean;
}

export const BackButton = styled(CircularIconButton)<BackButtonProps>`
  pointer-events: auto;

  @media (min-width: ${breakpoints.laptopMin}) {
    display: ${(props) => (props.$hideOnDesktop ? 'none' : 'flex')};
  }
`;

export const IconButton = CircularIconButton;

export const MenuTriggerButton = styled(motion(CircularIconButton))`
  position: absolute;
  top: 0;
  right: 0;
  transform-origin: top right;
`;
